if (!customElements.get("price-element")) {
  class PriceElement extends HTMLElement {
    constructor() {
      super();
      // Initialize with value from localStorage or default to private if not set
      this.selectedType = localStorage.getItem("selectedCustomerType") || "private";
    }

    connectedCallback() {
      // Always initialize prices, even without client-type-selector
      this.setPrices();

      // Watch for client type selector if it exists
      if (document.querySelector("client-type-selector")) {
        this.getLocalStorage();
        this.setPrices();
      }
    }

    updatePrice() {
      const currentType = this.selectedType;
      this.getLocalStorage();
      if (currentType !== this.selectedType) {
        this.setPrices();
      }
    }

    getLocalStorage() {
      const storedType = localStorage.getItem("selectedCustomerType");
      if (storedType) {
        this.selectedType = storedType;
      }
    }

    setPrices() {
      const privatePriceElements = this.querySelectorAll(".js-private-price");
      const corporatePriceElements = this.querySelectorAll(".js-corporate-price");

      // If no price elements found for the selected type, don't hide the other type
      const hasPrivatePrices = privatePriceElements.length > 0;
      const hasCorporatePrices = corporatePriceElements.length > 0;

      if (this.selectedType === "private") {
        // Only hide corporate prices if we have private prices
        if (hasPrivatePrices) {
          privatePriceElements.forEach(el => el.classList.remove("hidden"));
          corporatePriceElements.forEach(el => el.classList.add("hidden"));
        }
      } else {
        // Only hide private prices if we have corporate prices
        if (hasCorporatePrices) {
          privatePriceElements.forEach(el => el.classList.add("hidden"));
          corporatePriceElements.forEach(el => el.classList.remove("hidden"));
        }
      }

      // If no prices found for current type, try to show the other type
      if ((this.selectedType === "private" && !hasPrivatePrices && hasCorporatePrices) ||
          (this.selectedType === "corporate" && !hasCorporatePrices && hasPrivatePrices)) {
        privatePriceElements.forEach(el => el.classList.remove("hidden"));
        corporatePriceElements.forEach(el => el.classList.remove("hidden"));
      }

      // Dispatch event for other components that might need to know about price changes
      this.dispatchEvent(new CustomEvent('priceUpdate', {
        bubbles: true,
        detail: { 
          type: this.selectedType,
          hasPrivatePrices,
          hasCorporatePrices
        }
      }));
    }
  }

  customElements.define("price-element", PriceElement);
}